/*
 * @Description: 单位会话 配置
 * @Date: 2026-09-23
 */

import { ref } from 'vue'
import { enumToOption } from '@/utils'

// 授权状态：0-待授权 2-已授权
export enum accreditStatusEnum {
  待授权 = 0,
  已授权 = 2
}

export const accreditStatusOption = enumToOption(accreditStatusEnum)

// 搜索配置
export const inputList = (remoteData1: any) => [
  {
    type: 'select',
    label: '企业名称',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 340,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'select-remote-pagination',
    label: '关联资产',
    key: 'settingId',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    requestUrl: '/enterpriseViolationSetting/query',
    requestKey: 'orgName',
    labelKey: 'orgName',
    valueKey: 'id',
    remote: true
  },
  {
    type: 'input',
    label: '设备号',
    key: 'deviceNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '是否登录',
    key: 'active',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      { label: '是', value: true },
      { label: '否', value: false }
    ]
  },
  {
    type: 'select',
    label: '授权状态',
    key: 'accreditStatus',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: accreditStatusOption,
    rules: {
      type: 'number'
    }
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '心跳时间始',
    key: 'lastHeartbeatStart',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '心跳时间止',
    key: 'lastHeartbeatEnd',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '合同办理始',
    key: 'lastContractTimeStart',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '合同办理止',
    key: 'lastContractTimeEnd',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '违章同步始',
    key: 'lastViolationTimeStart',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '违章同步止',
    key: 'lastViolationTimeEnd',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '创建时间始',
    key: 'createTimeStart',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 100,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '创建时间止',
    key: 'createTimeEnd',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 100,
    inputWidth: 200,
    isArea: true
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}

// 表格配置
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 的高度
    height: null,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'companyName',
      label: '公司名称',
      width: '160',
      formatter: (row: any) => row.companyName || '-'
    },
    {
      key: 'deviceNo',
      label: '设备号',
      width: '160',
      formatter: (row: any) => row.deviceNo || '-'
    },
    {
      key: 'orgName',
      label: '单位名称',
      width: '160',
      formatter: (row: any) => row.orgName || '-'
    },
    {
      key: 'orgCertCode',
      label: '单位证书编号',
      width: '160',
      formatter: (row: any) => row.orgCertCode || '-'
    },
    {
      key: 'settingId',
      label: '违章配置id',
      width: '120',
      formatter: (row: any) =>
        row.settingId === null || row.settingId === undefined
          ? '-'
          : row.settingId
    },
    {
      key: 'username',
      label: '账号',
      width: '140',
      formatter: (row: any) => row.username || '-'
    },
    {
      key: 'active',
      label: '是否登录',
      width: '100',
      formatter: (row: any) => (row.active === true ? '是' : '否')
    },
    {
      key: 'accreditStatus',
      label: '授权状态',
      width: '100',
      formatter: (row: any) =>
        row.accreditStatus === null || row.accreditStatus === undefined
          ? '-'
          : accreditStatusEnum[row.accreditStatus]
    },
    {
      key: 'lastHeartbeat',
      label: '上一次心跳时间',
      width: '160',
      formatter: (row: any) => row.lastHeartbeat || '-'
    },
    {
      key: 'lastContractTime',
      label: '上一次合同办理',
      width: '160',
      formatter: (row: any) => row.lastContractTime || '-'
    },
    {
      key: 'lastViolationTime',
      label: '上一次违章同步',
      width: '160',
      formatter: (row: any) => row.lastViolationTime || '-'
    },
    {
      key: 'contractDuration',
      label: '合同办理耗时',
      width: '120',
      formatter: (row: any) => row.contractDuration || '-'
    },
    {
      key: 'violationDuration',
      label: '违章同步耗时',
      width: '120',
      formatter: (row: any) => row.violationDuration || '-'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '160',
      formatter: (row: any) => row.createTime || '-'
    },
    {
      key: 'updateTime',
      label: '更新时间',
      width: '160',
      formatter: (row: any) => row.updateTime || '-'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}
